/**
* @param {string} messageHeader
* @param {string} message
*/
function ErrorMessage(props){

    let messageHeader = "Feil oppstått";
    let message = "Det har skjedd en feil, vennligst prøv igjen senere.";

    if(props.message !== undefined && props.message !== null && props.message !== "")
    {
        message = props.message
    }

    if(props.messageHeader !== undefined && props.messageHeader !== null && props.messageHeader !== "")
    {
        messageHeader = props.messageHeader
    }

    return( 
        <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">{messageHeader}</h4>
            <p className="alert-message-text">{message}</p>
        </div>
    ); 
}

export default ErrorMessage;